import { useState, useRef, useEffect } from "react";

const capTitle = {
    'all': 'All',
    'player': 'Player',
    'ally': 'Ally',
    'monster': 'Enemy',
}

const EditTvTablePositionDropdown = ({creatureType, currentSides, handlePvOptionChange}) => {
    const [open, setOpen] = useState(false);
    const [selectedSides, setSelectedSides] = useState(currentSides);
    const dropdownRef = useRef(null);

    const handleSideClick = (newSide) => {
        if(newSide === 'Center') return;

        // Add or remove
        let newList = []
        if(selectedSides.includes(newSide)) {
            newList = selectedSides.filter(s => s !== newSide)
        } else {
            newList = [...selectedSides, newSide]
        }
        newList = newList.filter(str => str !== "");
        setSelectedSides([...newList])
        handlePvOptionChange("tableView", "position", newList.join(','))
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="positionContainer" ref={dropdownRef} style={{minWidth: "63px", marginLeft: '5px'}}>
            <div className="positionTitleContainer" style={{outline: open ? "1px solid #919191" : ''}} onClick={() => setOpen(o => !o)}>
                <span style={{paddingLeft: "5px"}}>{selectedSides.map(s => s.slice(0,1)).join(" ")}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(90deg)",
                    minWidth: "16px",
                    minHeight: "16px"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="#555555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            
            {open && (
                <div className="positionGridContainer" style={{outline: "1px solid #919191"}} >
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div><b>{capTitle[creatureType]} Icon Positions</b>: {selectedSides.join(' ')}</div>
                    </div>
                    <ul className="positionDropdownList">
                        {['Center', 'Top', 'Right', 'Left', 'Bottom'].map((side, i) => (
                            <li key={side+'li'} className={`positionTvTableLi ${side}`} 
                                style={{outline: selectedSides.includes(side) ? '3px solid #584f3bff' : ''}} 
                                onClick={() => handleSideClick(side)}
                            >
                                {side}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default EditTvTablePositionDropdown;